export const isBalanceBillingMode = (value) =>
  value === 'balance_full' || value === 'balance_trainer_only';

export const isTrainerOnlyBillingMode = (value) =>
  value === 'trainer_only' || value === 'balance_trainer_only';

export const isFullFeeBillingMode = (value) =>
  value === 'full' || value === 'balance_full';

export const calculateClubCourtCost = ({
  courtFeeHuf,
  trainingDurationHours,
  courtCount,
  participantCount,
  fullFeeParticipantCount,
}) => {
  const normalizedParticipantCount = Math.max(Number(participantCount) || 0, 0);
  const normalizedFullFeeParticipantCount = Math.max(Number(fullFeeParticipantCount) || 0, 0);

  if (normalizedParticipantCount <= 0) {
    return {
      courtFeePerPersonHuf: 0,
      clubCourtCostHuf: 0,
    };
  }

  const courtFeePerPersonHuf = Math.ceil(
    (Math.max(Number(courtFeeHuf) || 0, 0)
      * Math.max(Number(trainingDurationHours) || 0, 0)
      * Math.max(Number(courtCount) || 0, 0))
    / normalizedParticipantCount,
  );

  return {
    courtFeePerPersonHuf,
    clubCourtCostHuf: courtFeePerPersonHuf * normalizedFullFeeParticipantCount,
  };
};

export const resolveBillingSettlement = ({
  amountHuf,
  billingMode,
  balanceHuf,
  allowNegativeBalance,
}) => {
  const normalizedAmountHuf = Math.max(Number(amountHuf) || 0, 0);
  const normalizedBalanceHuf = Number(balanceHuf) || 0;
  const balanceBillingMode = isBalanceBillingMode(billingMode);

  if (normalizedAmountHuf <= 0 || billingMode === 'none') {
    return {
      balanceBillingMode,
      balanceDeductionHuf: 0,
      balanceAfterHuf: normalizedBalanceHuf,
      needsInvoice: false,
    };
  }

  const balanceCoversAmount = normalizedBalanceHuf >= normalizedAmountHuf;
  const canChargeBalance = balanceCoversAmount
    || (balanceBillingMode && allowNegativeBalance === true);
  const balanceDeductionHuf = canChargeBalance ? normalizedAmountHuf : 0;

  return {
    balanceBillingMode,
    balanceDeductionHuf,
    balanceAfterHuf: normalizedBalanceHuf - balanceDeductionHuf,
    needsInvoice: balanceDeductionHuf <= 0,
  };
};
